import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-vehicle-availability-graph',
    templateUrl: './vehicle-availability-graph.component.html',
    styleUrls: ['./vehicle-availability-graph.component.scss'],
    standalone: false
})
export class VehicleAvailabilityGraphComponent implements OnInit {
  dataBar = [
    { name: 'Available', value: 38 },
    { name: 'Unavailable', value: 12 },
  ];

  view: any[] = [];
  gradient: boolean = false;
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  showYAxisLabel: boolean = true;
  yAxisLabel: string = 'Vehicles';

  colorScheme = {
    domain: ['#5AA454', '#e51c23']
  };

  constructor() { }

  ngOnInit(): void {
  }

}
